// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div-top[data-v-5d44e793]{display:flex;justify-content:space-between;align-items:flex-start}.btn-close[data-v-5d44e793]{transform:translate(10px,-5px)}.spacer[data-v-5d44e793]{margin-top:.5rem}.card[data-v-5d44e793]{background-color:var(--color-divider);padding:2rem}.subtitle[data-v-5d44e793]{font-size:small}", ""]);
// Exports
module.exports = exports;
